import { ServiceResult } from '../models';
import {
  CreateRecipeMenuWorksheetRequest,
  DeleteRecipeMenuWorksheetRequest,
  RecipeMenuWorksheet,
  RecipeMenuWorksheetHeader,
  UpdateRecipeMenuWorksheetRecipeFoodCostAndSellPriceRequest,
  UpdateRecipeMenuWorksheetRecipeTotalNumberSoldRequest,
  UpdateRecipeMenuWorksheetRequest,
} from '../models/recipe-menu-worksheet.models';

import ApiService from './api-service';

class RecipeMenuWorksheetService extends ApiService {
  private static classInstance: RecipeMenuWorksheetService;

  private constructor() {
    super('RecipeMenuWorksheet');
  }

  public static getInstance(): RecipeMenuWorksheetService {
    if (!this.classInstance) {
      this.classInstance = new RecipeMenuWorksheetService();
    }
    return this.classInstance;
  }

  public createRecipeMenuWorksheetHeader(
    request: CreateRecipeMenuWorksheetRequest
  ): ServiceResult<RecipeMenuWorksheetHeader> {
    return this.post(`${this.baseUrl}/CreateRecipeMenuWorksheetHeader`, request);
  }

  public getRecipeMenuWorksheetHeaders(customerId: string): ServiceResult<RecipeMenuWorksheetHeader[]> {
    return this.get(`${this.baseUrl}/GetRecipeMenuWorksheetHeaders?customerId=${customerId}`);
  }

  public updateRecipeMenuWorksheetHeader(
    request: UpdateRecipeMenuWorksheetRequest
  ): ServiceResult<RecipeMenuWorksheetHeader> {
    return this.post(`${this.baseUrl}/UpdateRecipeMenuWorksheetHeader`, request);
  }

  public deleteRecipeMenuWorksheetHeader(request: DeleteRecipeMenuWorksheetRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeMenuWorksheetHeader`, request);
  }

  public getRecipeMenuWorksheet(worksheetHeaderId: string): ServiceResult<RecipeMenuWorksheet> {
    return this.get(`${this.baseUrl}/GetRecipeMenuWorksheet?recipeMenuWorksheetHeaderId=${worksheetHeaderId}`);
  }

  public updateTotalSold(
    request: UpdateRecipeMenuWorksheetRecipeTotalNumberSoldRequest
  ): ServiceResult<RecipeMenuWorksheet> {
    return this.post(`${this.baseUrl}/UpdateRecipeMenuWorksheetRecipeTotalNumberSold`, request);
  }

  public updateFoodCostAndSellPrice(
    request: UpdateRecipeMenuWorksheetRecipeFoodCostAndSellPriceRequest
  ): ServiceResult<RecipeMenuWorksheet> {
    return this.post(`${this.baseUrl}/UpdateRecipeMenuWorksheetRecipeFoodCostAndSellPrice`, request);
  }
}

export default RecipeMenuWorksheetService;
